"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _Settings = require('./Settings'); var _Settings2 = _interopRequireDefault(_Settings);
var _Netstats = require('./Netstats'); var _Netstats2 = _interopRequireDefault(_Netstats);

exports.SettingsModal = _Settings2.default; exports.NetstatsModal = _Netstats2.default;
